import React, { useState } from 'react'
import { Grid, Box } from '@mui/material'
import { LoadingButton } from '@mui/lab'
import DownloadIcon from '@mui/icons-material/Download'
import AttachEmailIcon from '@mui/icons-material/AttachEmail'
import VisibilityIcon from '@mui/icons-material/Visibility'
import BookmarkIcon from '@mui/icons-material/Bookmark'
import BookmarkAddedIcon from '@mui/icons-material/BookmarkAdded'

import DocumentSendDialog from './DocumentSendDialog'
import { downloadDocument } from 'api/DocumentAPI'

import { useNotificationStore } from 'store/NotificationStore'
import { useLibraryStore } from 'store/LibraryStore'

import './Document.scss'
const ActionButton = ({ loading, onClick, children }) => (
  <Box className='action-button'>
    <LoadingButton 
      size="small"
      loading={loading}
      fullWidth
      variant="contained"
      onClick={onClick}
    >
      {children}
    </LoadingButton>
  </Box>
)
export default function DocumentActions({document}) {
  const { addToLibrary, deleteFromLibrary } = useLibraryStore()
  const { addNotification } = useNotificationStore()
  const [loadingDownload, setLoadingDownload] = useState(false)
  const [loadingAddToLibrary, setLoadingAddToLibrary] = useState(false)
  const [sendModalOpen, setSendModalOpen] = useState(false)
  const [loadingSend, setLoadingSend] = useState(false)


  const onDownload = () => {
    setLoadingDownload(true);
    downloadDocument(
      document.id,
      () => {
        setLoadingDownload(false);
        addNotification({
          type: "success",
          message: "Pobieranie zakończone pomyślnie",
        });
      },
      (error) => {
        setLoadingDownload(false);
        // setError("Wystąpił błąd podczas pobierania pliku: " + error);
        addNotification({
          type: "error",
          message: "Wystąpił błąd podczas pobierania pliku: " + error,
        });
      }
    );
  };

  const onLibraryAdd = () => {
    setLoadingAddToLibrary(true);
    addToLibrary(document.id,);
    setLoadingAddToLibrary(false);
    document.book_in_library = true;
    
    addNotification({
      type: "success",
      message: "Dokument został dodany do biblioteki",
    });
  }

  const onLibraryRemove = () => {
    setLoadingAddToLibrary(true);
    deleteFromLibrary(document.id);
    setLoadingAddToLibrary(false);
    document.book_in_library = false;
    addNotification({
      type: "success",
      message: "Dokument został usunięty z biblioteki",
    });
  }

  const onSend = () => {
    setSendModalOpen(true);
    setLoadingSend(false);
  }

  const onPreview = () => {
    
  }

  return (
    <Box className="document-actions">
    <Grid container>
      <Grid item xs={3}>
        <ActionButton loading={loadingDownload} onClick={onDownload} children={<DownloadIcon />}/>
      </Grid>
      <Grid item xs={3}>
        <ActionButton loading={loadingSend} onClick={onSend} children={<AttachEmailIcon />}/>
      </Grid>
      <Grid item xs={3}>
        <ActionButton loading={false} onClick={onPreview} children={<VisibilityIcon />}/>
      </Grid>
      <Grid item xs={3}>
        <ActionButton
          loading={loadingAddToLibrary}
          onClick={() => {
            document.book_in_library ? onLibraryRemove() : onLibraryAdd()
          }}
          children={document.book_in_library ? <BookmarkAddedIcon /> : <BookmarkIcon />}
        />
      </Grid>
    </Grid>

    <DocumentSendDialog
      open={sendModalOpen}
      document={document}
    />

    
    </Box>
  )
}
